import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 px-4 bg-brand-cream" data-id="element-78">
      <div className="max-w-3xl mx-auto" data-id="element-79">
        <div className="bg-white border-4 border-brand-petrol/30 p-5 sm:p-6 rounded-xl text-center" data-id="element-80">
          <p className="text-sm font-bold text-brand-petrol uppercase tracking-wide mb-2" data-id="element-81">
            Ihre Investition ist 100% geschützt
          </p>
          <div className="w-16 h-16 mx-auto bg-brand-petrol/10 rounded-full flex items-center justify-center mb-3" data-id="element-82">
            <ShieldCheck className="w-8 h-8 text-brand-petrol" data-id="element-83" />
          </div>
          <h3 className="text-xl sm:text-2xl font-serif font-bold text-brand-graphite mb-3" data-id="element-84">
            🛡️ 7-Tage-Geld-zurück-Garantie
          </h3>
          <p className="text-base text-brand-graphite/80 max-w-2xl mx-auto leading-relaxed" data-id="element-85">
            Ihr Kauf ist völlig risikolos. Nehmen Sie sich sieben volle Tage, um
            das gesamte System zu erkunden, jedes Modul zu überprüfen, die
            Frameworks zu implementieren, Ihren Workflow zu organisieren und die
            Ressourcen mit Ihren Kunden zu nutzen. Wenn Sie aus irgendeinem
            Grund nicht vollständig zufrieden sind, kontaktieren Sie uns einfach
            innerhalb der ersten 7 Tage und wir erstatten Ihnen 100% Ihres
            Kaufpreises. Kein Risiko. Keine Fragen gestellt.
          </p>
        </div>
      </div>
    </section>;
}